/* eslint-disable */
/* global google */

export default {
  init() {

    $(function initMap() {

    var latLng = { lat: 51.5409703, lng: -3.138737 }

    var myOptions = {
      zoom: 14,
      center: latLng,
      styles:
      [
          {
              "featureType": "landscape.natural",
              "elementType": "geometry.fill",
              "stylers": [
                  {
                      "visibility": "on"
                  },
                  {
                      "color": "#e3e3e3"
                  }
              ]
          },
          {
              "featureType": "poi",
              "elementType": "geometry.fill",
              "stylers": [
                  {
                      "visibility": "on"
                  },
                  {
                      "hue": "#1900ff"
                  },
                  {
                      "color": "#c0e8e8"
                  }
              ]
          },
          {
              "featureType": "road",
              "elementType": "geometry",
              "stylers": [
                  {
                      "lightness": 100
                  },
              ]
          },
          {
              "featureType": "road",
              "elementType": "labels",
              "stylers": [
                  {
                      "visibility": "on"
                  }
              ]
          },
          {
              "featureType": "transit.line",
              "elementType": "geometry",
              "stylers": [
                  {
                      "visibility": "on"
                  },
                  {
                      "lightness": 700
                  }
              ]
          },
          {
              "featureType": "water",
              "elementType": "all",
              "stylers": [
                  {
                      "color": "#addbdb"
                  }
              ]
          }
      ]
    };
    
    var map = new google.maps.Map( document.getElementById( "map" ), myOptions );
    
    var bounds = new google.maps.LatLngBounds();

    var locations = [
      [ '<strong>MPCT</strong><br>MPCT House<br> Oak Tree Court<br> Mulberry Drive<br> Cardiff Gate Business Park<br> CF23 8RS', 51.5409703, -3.138737 ],
    ];

    for ( var i = 0; i < locations.length; i++ )
    {

      var location = locations[ i ];
    
      var position = new google.maps.LatLng( location[ 1 ], location[ 2 ] );
    
      var marker = new google.maps.Marker({
        animation: google.maps.Animation.DROP,
        map: map,
        position: position,
        title: location[ 0 ],
      });
      
      google.maps.event.addListener( marker, 'click', ( 
        function( marker, i ) {
          return function() {
            map.panTo(marker.getPosition());
            map.setZoom(18);
            map.setCenter(marker.getPosition());  
            var infowindow = new google.maps.InfoWindow();
            infowindow.setContent( locations[ i ][ 0 ] );
            infowindow.open( map, marker );
          }
        }
      )( marker, i ) );
    };
    })
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/contact.js